import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Barre de pagination alignée sur le design du composant shared (Afficher + boîtes « « ‹ … › » »).
 * L’état (page courante, taille) reste géré par le composant parent.
 */
@Component({
    selector: 'app-table-pagination-bar',
    templateUrl: './table-pagination-bar.component.html',
    styleUrls: ['./table-pagination-bar.component.scss']
})
export class TablePaginationBarComponent {
    /** Nombre total d’éléments après filtrage côté parent. */
    @Input() totalItems = 0;
    /** Indice de début affiché (1-based), ex. 1. */
    @Input() pageFrom = 0;
    /** Indice de fin affiché, ex. 10. */
    @Input() pageTo = 0;
    /** Page courante (bornée), pour l’affichage et les boutons. */
    @Input() currentPage = 1;
    @Input() totalPages = 1;
    @Input() pageSize = 10;
    @Input() pageSizeOptions: number[] = [10, 25, 50, 100];

    /** Texte après le total : « mouvement(s) », « ligne(s) », etc. */
    @Input() itemsLabel = 'élément(s)';
    /** Afficher la ligne « a – b sur n … » sous « Afficher ». */
    @Input() showItemRange = true;
    /** Attribut aria-label sur la zone de navigation. */
    @Input() ariaLabel = 'Pagination';
    /** Classe(s) CSS sur le conteneur racine (ex. marges). */
    @Input() containerClass = '';
    /** Suffixe unique pour l’attribut `name` du select si plusieurs barres sur la même vue. */
    @Input() nameSuffix = 'default';

    /** Émet le numéro de page cible (1-based). */
    @Output() pageChange = new EventEmitter<number>();
    /** Émet la nouvelle taille de page. */
    @Output() pageSizeChange = new EventEmitter<number>();

    get pageNumbers(): number[] {
        const n = Math.max(0, Math.floor(this.totalPages));
        return Array.from({ length: n }, (_, i) => i + 1);
    }

    get displayItemRange(): boolean {
        return this.showItemRange && this.pageFrom > 0 && this.pageTo > 0;
    }

    onPageSizeSelect(value: number): void {
        this.pageSizeChange.emit(Number(value));
    }

    goFirst(): void {
        if (this.currentPage <= 1) {
            return;
        }
        this.pageChange.emit(1);
    }

    goPrev(): void {
        if (this.currentPage <= 1) {
            return;
        }
        this.pageChange.emit(this.currentPage - 1);
    }

    goNext(): void {
        if (this.currentPage >= this.totalPages) {
            return;
        }
        this.pageChange.emit(this.currentPage + 1);
    }

    goLast(): void {
        if (this.currentPage >= this.totalPages) {
            return;
        }
        this.pageChange.emit(this.totalPages);
    }

    goToPageNum(page: number): void {
        if (page === this.currentPage || page < 1 || page > this.totalPages) {
            return;
        }
        this.pageChange.emit(page);
    }
}
